import { Injectable } from '@angular/core';
import { EnvironmentService } from '../services/enviroment.service';
import { environment } from '../services/global-environment';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';  // 引入錯誤處理操作符
import { HttpClient } from '@angular/common/http';
import axios from 'axios';
import { TopicTagsResponse } from '../models/api-response.model';

// export type TargetContainer =  'form-container' | 'form-config' | 'regulation-container' | 'modules'  | 'users';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

 private apiUrl = environment.apiUrl;  // 從環境變數讀取後端 API URL

 constructor(private http: HttpClient) {}

// 取得指定公司 ID 的用戶資料
getUsersByCompanyId(companyId: string) {
  const url = `${this.apiUrl}/api/users/getusers`;
  return this.http.get<any>(url, { params: { companyId } });
}

// 將資料發送到後端 API
async sendDataToBackend(data: any,targetcontainer:string = "form-container"): Promise<any> {
  try {
    // console.log('Data to send:', `${this.apiUrl}/api/cosmosdb/saveData/${targetcontainer}`);

    const response = await axios.post(
      `${this.apiUrl}/api/cosmosdb/saveData/${targetcontainer}`,
      data,
      { headers: { 'Content-Type': 'application/json' } }
    );

    // console.log('Data successfully sent to backend:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error sending data to backend:', error);
    throw error;
  }
}

//   // 呼叫 getDatabyquery API，並傳遞查詢參數
//  // 使用 axios 呼叫 getDatabyquery API，並傳遞查詢參數
getDataByQuery(filter: any, pageSize: number = 10,targetcontainer:string): Observable<any> {

  // 構造查詢字串
  let params = new URLSearchParams();
  params.set('filter', JSON.stringify(filter));  // 將過濾條件轉換為 JSON 字串並傳遞
  params.set('pageSize', pageSize.toString());


  // if (continuationToken) {
  //   params.set('continuationToken', continuationToken);
  // }

  // 正確的 API 路徑
  const url = `${this.apiUrl}/api/cosmosdb/getDatabyquery/${targetcontainer}`;  // 更新 URL 路徑

  // 使用 axios 發送 GET 請求
  return new Observable(observer => {
    axios.get(url, { params })  // 使用正確的 URL
      .then(response => {
        observer.next(response.data);
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
  });
}

getFormCount(companyid: string): Observable<any> {

  // 構造查詢字串
  let params = new URLSearchParams();
  params.set('companyid', companyid);  // 將過濾條件轉換為 JSON 字串並傳遞

  // if (continuationToken) {
  //   params.set('continuationToken', continuationToken);
  // }

  // 正確的 API 路徑
  const url = `${this.apiUrl}/api/cosmosdb/getFormCount`;  // 更新 URL 路徑

  // 使用 axios 發送 GET 請求
  return new Observable(observer => {
    axios.get(url, { params })  // 使用正確的 URL
      .then(response => {
        observer.next(response.data);
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
  });
}

get_compliance_tab_list(companyid: string,topic:string): Observable<any> {

  // 構造查詢字串
  let params = new URLSearchParams();
  params.set('companyid', companyid);  // 將過濾條件轉換為 JSON 字串並傳遞
  params.set('topic', topic);

  // if (continuationToken) {
  //   params.set('continuationToken', continuationToken);
  // }

  // 正確的 API 路徑
  const url = `${this.apiUrl}/api/cosmosdb/get_compliance_tab_list`;  // 更新 URL 路徑

  // 使用 axios 發送 GET 請求
  return new Observable(observer => {
    axios.get(url, { params })  // 使用正確的 URL
      .then(response => {
        observer.next(response.data);
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
  });
}

get_compliance_result(companyid: string,topic:string,mission_name:string,law_id:string): Observable<any> {

  // 構造查詢字串
  let params = new URLSearchParams();
  params.set('companyid', companyid);  // 將過濾條件轉換為 JSON 字串並傳遞
  params.set('topic', topic);
  params.set('mission_name', mission_name);
  params.set('law_id', law_id);

  // if (continuationToken) {
  //   params.set('continuationToken', continuationToken);
  // }

  // 正確的 API 路徑
  const url = `${this.apiUrl}/api/cosmosdb/get_compliance_regulation_and_result`;  // 更新 URL 路徑

  // 使用 axios 發送 GET 請求
  return new Observable(observer => {
    axios.get(url, { params })  // 使用正確的 URL
      .then(response => {
        observer.next(response.data);
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
  });
}

// 取得指定公司和主題下所有不重複的標籤
getTopicTags(companyid: string, topic: string): Observable<TopicTagsResponse> {
  // 正確的 API 路徑
  const url = `${this.apiUrl}/api/regulation/get_tags`;

  // 請求體資料
  const requestBody = {
    companyid: companyid,
    topic: topic
  };

  // 使用 axios 發送 POST 請求
  return new Observable<TopicTagsResponse>(observer => {
    axios.post(url, requestBody, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        observer.next(response.data);
        observer.complete();
      })
      .catch(error => {
        console.error('Error getting topic tags:', error);
        observer.error(error);
      });
  });
}

getexamquestions(courseName: string, numQuersion: number = 80): Observable<any> {

  // 構造查詢字串
  let params = new URLSearchParams();
  params.set('courseName', courseName);
  params.set('numQuestions', numQuersion.toString());  // 將 numQuersion 轉換為字串

  // 正確的 API 路徑
  const url = `${this.apiUrl}/api/examdb/getQuestions`;  // 更新 URL 路徑

  // 使用 axios 發送 GET 請求
  return new Observable(observer => {
    axios.get(url, { params })  // 使用正確的 URL
      .then(response => {
        observer.next(response.data);
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
  });
}

// 更新資料到後端 API
async updateData(data: any, targetcontainer: string = "form-container"): Promise<any> {
  try {
    const response = await axios.put(
      `${this.apiUrl}/api/cosmosdb/updateData/${targetcontainer}`,
      data,
      { headers: { 'Content-Type': 'application/json' } }
    );

    console.log('Data successfully updated:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating data:', error);
    throw error;
  }
}

// 從後端 API 刪除資料
async deleteData(id: string, targetcontainer: string = "form-container"): Promise<any> {
  try {
    const response = await axios.delete(
      `${this.apiUrl}/api/cosmosdb/deleteData/${targetcontainer}/${id}`
    );

    console.log('Data successfully deleted:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting data:', error);
    throw error;
  }
}

// 刪除表單及其相關資料
deleteForm(companyid: string, id: string): Observable<any> {
  const requestData = {
    companyid: companyid,
    id: id
  };

  const url = `${this.apiUrl}/api/form-manager/delete_form`;

  // 使用 axios 發送 POST 請求
  return new Observable(observer => {
    axios.post(url, requestData, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        console.log('Form successfully deleted:', response.data);
        observer.next(response.data);
        observer.complete();
      })
      .catch(error => {
        console.error('Error deleting form:', error);
        observer.error(error);
      });
  });
}


}
